export function pushGaDataForMsw(data) {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', '/storybook-ga-tags', true);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send(JSON.stringify({
    data,
  }));
}
